/**
 * BMT Companion: a trainee's sign-up, dates, check-in state and homework for BMT,
 * served by hogc-one-api under /api/v2/training/bmt.
 */

// The string is the contract with hogc-one-api (BMT_COMPANION_FLAG). The API 404s
// every BMT route while it is off; the app hides the home card and guards /bmt.
export const BMT_COMPANION_FLAG = 'bmt-companion';

/** The scanner type the API mints BMT check-in QRs with: https://hogc.one/scan/bmt/checkin/{token}. */
export const BMT_SCAN_TYPE = 'bmt';

/** The trainee routes, relative to VUE_APP_API_URL (which already ends in /api). */
export const BMT_API_PATH = '/v2/training/bmt';

/** Re-read /me on page enter or app resume only when the last read is older than this. */
export const BMT_ME_STALE_MS = 60 * 1000;

/** Where an unsent TEXT homework answer is kept on the device, one key per homework id. */
export const BMT_DRAFT_KEY_PREFIX = 'bmt-homework-draft:';

export const BMT_HUB_PATH = '/bmt';
export const BMT_SCHEDULE_PATH = '/bmt/schedule';
export const BMT_RESOURCES_PATH = '/bmt/resources';
export const BMT_TASKS_PATH = '/bmt/tasks';
/** A written task (the testimony), full screen. */
export const bmtTaskPath = id => `${BMT_TASKS_PATH}/${id}`;

/** Who each course is for, under its name on the hub and its pages. */
export const BMT_COURSE_AUDIENCE = Object.freeze({
  BMT: 'For Pre-Uni & above',
  'BMT Youth': 'For Youth & JC',
});

export const BMT_RESOURCE_KIND = Object.freeze({
  VIDEO: 'VIDEO',
  FILE: 'FILE',
  LINK: 'LINK',
});

/** A written task saves its draft this long after typing stops. */
export const BMT_DRAFT_SAVE_MS = 2000;

/** Where a BMT check-in scan lands with its result (bmt.lastCheckIn). */
export const BMT_CHECK_IN_PATH = '/bmt/check-in';

export const BMT_ENROLMENT_STATUS = Object.freeze({
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  WITHDRAWN: 'WITHDRAWN',
});

export const BMT_HOMEWORK_TYPE = Object.freeze({
  TICK: 'TICK',
  TEXT: 'TEXT',
});

/** The `cgNote` sent when the member says they are not in a Connect Group yet. */
export const BMT_CG_NOTE_NOT_YET = 'Not yet';

/** Before the CG name in the `cgNote` sent when the member says they are in one. */
export const BMT_CG_NOTE_YES_PREFIX = 'Yes: ';

/** The API caps cgNote at 200 characters; a written task is held to 5,000 here. */
export const BMT_CG_NOTE_MAX = 200;
export const BMT_TEXT_MAX = 5000;
